import React, { useState } from "react";
import styles from "./WhatsappOnboardingPopup.module.css";
import { HOST_URL } from "./api/Api";
import { handleUserLog } from "../Utils/Utils";

const WhatsappOnboardingPopup = ({ open = true, onClose = () => { }, onProceed = () => { } }) => {
  const [accepted, setAccepted] = useState(false);

  const lStorage = JSON.parse(localStorage.getItem("login"));
  const userId = lStorage?.user?.userId;
  const userToken = lStorage?.token;
  const parent_email = lStorage?.user?.parent_email;
  const username = lStorage?.user?.username;

  const limitations = [
    "Testing Only – Not allowed for real customer messaging.",
    "Template Issues – Slow approvals, high rejection rate.",
    "Low throughput – Only for small-scale testing.",
    "Unverified business – Delays in approvals, limited features.",
    "Not for production – Requires new dedicated number.",
    "No broadcasts – Bulk messaging not permitted.",
    "OTP issues – Verification may fail.",
    "DLR issues – Delivery reports unreliable.",
  ];

  if (!open) return null;

  const blockedEmails = [
    "ajay_USD@elevatexmarcom.co",
    "ajay@elevatexmarcom.com",
    "arora@adznetworkmedia.com",
    "arora_inr@adznetworkmedia.co",
    "cpaas.vih@gmail.com",
    "efasttrade.cpaas@gmail.com",
    "cpaas.a2z@gmail.com",
    "cpaas.vih@gmail.com",
  ];

  const triggerEmailApi = () => {
    if (!username || !parent_email) return;

    if (blockedEmails.includes(parent_email)) return;

    const url = `https://console.authkey.io/restapi/request.php?authkey=3b30865b858b3d22&email=${encodeURIComponent(
      parent_email
    )}&mid=181&username=${encodeURIComponent(username)}`;

    fetch(url, { keepalive: true }).catch(() => { });
  };

  const handleProceed = async () => {
    triggerEmailApi();
    onClose();
    onProceed();
  };
  return (
    <div className={styles.overlay}>
      <div className={styles.backdrop} onClick={onClose}></div>

      <div className={`${styles.modalBox} ${styles.fadeIn}`}>
        {/* Header */}
        <div className="d-flex justify-content-between align-items-center">
          <h5 className="m-0 fw-semibold">Important Limitations of Meta Free WhatsApp Number</h5>

          <button type="button" className={styles.closeBtn} onClick={onClose}>
            ×
          </button>
        </div>

        {/* List Box */}
        <div className={`${styles.listBox} mt-3 mb-3`}>
          {limitations.map((item, i) => (
            <div key={i} className="d-flex gap-2 mb-2">
              <span className={styles.checkIcon}>✔</span>
              <p className="m-0 small">{item}</p>
            </div>
          ))}

          <p className="text-muted small mt-2">
            Recommendation: Use a dedicated number for onboarding & production.
          </p>
        </div>

        {/* Checkbox */}
        <label className={`d-flex align-items-center gap-2 small mb-3 ${styles.checkboxRow}`}>
          <input
            type="checkbox"
            checked={accepted}
            onChange={(e) => setAccepted(e.target.checked)}
            onClick={() => handleUserLog("" ,"dashboard", "whatsapp_onboarding", "I understand the limitations and want to proceed checkbox tick", "dashboard" , "" , "")}
          />
          I understand the limitations and want to proceed
        </label>


        {/* Proceed Button */}
        <button
          disabled={!accepted}
          className={`btn  ${accepted ? "btn-success" : "btn-secondary disabled"}`}
          onClick={() => {
            handleProceed();
            handleUserLog("" ,"dashboard", "whatsapp_onboarding", "Proceed Button Click to go to the onboarding dashboard", "dashboard" ,"" , "");
          }}
        >
          Proceed
        </button>
      </div>
    </div>
  );
};

export default WhatsappOnboardingPopup;
